import { SeoPageData } from '../seoPages';

const loc = (slug: string, title: string, h1: string, metaTitle: string, metaDesc: string, metaKw: string, intro: string, services: { icon: string; title: string; desc: string }[], area: string, faq: { q: string; a: string }[], links: { label: string; slug: string }[], bc: string): SeoPageData => ({
  slug, title, type: 'location', metaTitle, metaDescription: metaDesc, metaKeywords: metaKw, h1, intro, services, serviceAreaText: area, faq, internalLinks: links,
  breadcrumbs: [{ label: 'Startseite', href: '/' }, { label: 'Pflege Mallorca', href: '/pflege-mallorca' }, { label: bc, href: `/${slug}` }],
});

export const locationPages: Record<string, SeoPageData> = {
  'pflege-palma': loc('pflege-palma', 'Pflege Palma', 'Pflege in Palma de Mallorca',
    'Pflege in Palma de Mallorca – Deutschsprachige Betreuung | Geis Care',
    'Professionelle deutschsprachige Pflege in Palma de Mallorca: Koerperpflege, Seniorenbetreuung, Arztbegleitung, 24h-Pflege.',
    'Pflege Palma, Pflege Palma de Mallorca, Seniorenbetreuung Palma, Hauspflege Palma',
    'In der Inselhauptstadt Palma bietet Geis Care professionelle, deutschsprachige Pflege und Betreuung. Ob Altstadt, Son Vida, Portixol oder Vororte – unsere diplomierte Krankenschwester kommt direkt zu Ihnen. Schnell und zuverlaessig.',
    [
      { icon: 'home', title: 'Hauspflege', desc: 'Professionelle Pflege zu Hause in ganz Palma.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zu Aerzten und Kliniken in Palma.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Zuverlaessige Medikamentengabe.' },
      { icon: 'cart', title: 'Alltagsbegleitung', desc: 'Einkaufen, Besorgungen, soziale Aktivitaeten.' },
      { icon: 'clock', title: '24h-Pflege', desc: 'Rund-um-die-Uhr-Pflege in Palma.' },
      { icon: 'heart', title: 'Seniorenbetreuung', desc: 'Liebevolle Begleitung fuer aeltere Menschen.' },
    ],
    'Einsatzgebiet in Palma: Altstadt, Son Vida, Portixol, Santa Catalina, El Terreno, Genova, Son Espanyolet und alle Stadtteile.',
    [
      { q: 'In welchen Stadtteilen von Palma sind Sie taetig?', a: 'In ganz Palma – von der Altstadt ueber Son Vida und Portixol bis zu den Vororten.' },
      { q: 'Wie schnell koennen Sie in Palma vor Ort sein?', a: 'In Palma koennen wir meist innerhalb weniger Stunden vor Ort sein.' },
      { q: 'Arbeiten Sie mit Kliniken in Palma zusammen?', a: 'Ja, wir arbeiten eng mit Son Espases, Quironsalud, Policlinica Miramar und weiteren Kliniken zusammen.' },
    ],
    [
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Pflege in Manacor', slug: 'pflege-manacor' },
      { label: 'Pflege in Andratx', slug: 'pflege-andratx' },
      { label: 'Aerzte auf Mallorca', slug: 'aerzte-mallorca' },
      { label: 'Kliniken auf Mallorca', slug: 'kliniken-mallorca' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
    ],
    'Pflege Palma',
  ),

  'pflege-manacor': loc('pflege-manacor', 'Pflege Manacor', 'Pflege in Manacor und Umgebung',
    'Pflege in Manacor – Deutschsprachige Betreuung Ost-Mallorca | Geis Care',
    'Professionelle Pflege in Manacor und Umgebung: Seniorenbetreuung, Hauspflege, Arztbegleitung. Deutschsprachig und zuverlaessig.',
    'Pflege Manacor, Seniorenbetreuung Manacor, Hauspflege Manacor, Pflege Ost-Mallorca',
    'In Manacor, Mallorcas zweitgroesster Stadt, bietet Geis Care umfassende Pflegeleistungen. Die Region mit Porto Cristo, Son Servera und umliegenden Fincas ist eines unserer Kerngebiete. Kurze Anfahrtswege und persoenliche Betreuung garantiert.',
    [
      { icon: 'home', title: 'Hauspflege', desc: 'Pflege zu Hause in Manacor und Umgebung.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zu Aerzten in Manacor und Palma.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Zuverlaessige Medikamentengabe.' },
      { icon: 'cart', title: 'Alltagsbegleitung', desc: 'Einkaufen, Besorgungen, Freizeitaktivitaeten.' },
      { icon: 'clock', title: '24h-Pflege', desc: 'Rund-um-die-Uhr-Pflege in der Region.' },
      { icon: 'heart', title: 'Seniorenbetreuung', desc: 'Liebevolle Begleitung im Alltag.' },
    ],
    'Einsatzgebiet: Manacor, Porto Cristo, Son Servera, Arta, Capdepera, Son Macia, Felanitx und umliegende Fincas.',
    [
      { q: 'Betreuen Sie auch Fincas ausserhalb von Manacor?', a: 'Ja, wir betreuen auch abgelegene Fincas im Umkreis von Manacor, Porto Cristo und Son Servera.' },
      { q: 'Gibt es deutschsprachige Aerzte in Manacor?', a: 'Ja, in Manacor gibt es deutschsprachige Aerzte. Fuer Fachaerzte begleiten wir Sie nach Palma.' },
      { q: 'Wie weit reicht Ihr Einsatzgebiet?', a: 'Wir decken die gesamte Region Ost-Mallorca ab: von Arta im Norden bis Felanitx im Sueden.' },
    ],
    [
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Pflege in Cala Millor', slug: 'pflege-cala-millor' },
      { label: 'Pflege in Sant Llorenc', slug: 'pflege-sant-llorenc' },
      { label: 'Pflege in Palma', slug: 'pflege-palma' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
    ],
    'Pflege Manacor',
  ),

  'pflege-sant-llorenc': loc('pflege-sant-llorenc', 'Pflege Sant Llorenc', 'Pflege in Sant Llorenc des Cardassar',
    'Pflege in Sant Llorenc des Cardassar – Betreuung Ost-Mallorca | Geis Care',
    'Pflege in Sant Llorenc des Cardassar und Sa Coma: Seniorenbetreuung, Hauspflege, Arztbegleitung. Deutschsprachig und persoenlich.',
    'Pflege Sant Llorenc, Pflege Sa Coma, Seniorenbetreuung Sant Llorenc',
    'Sant Llorenc und die Kuestenorte Sa Coma und S\'Illot sind beliebte Wohngebiete fuer deutsche Residenten. Geis Care bietet hier professionelle Pflege direkt vor Ihrer Haustuer.',
    [
      { icon: 'home', title: 'Hauspflege', desc: 'Pflege zu Hause in Sant Llorenc und Umgebung.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zu Aerzten in der Region und Palma.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Zuverlaessige Medikamentengabe.' },
      { icon: 'footprints', title: 'Spaziergaenge', desc: 'Begleitete Ausfluege an der Kueste.' },
      { icon: 'cart', title: 'Einkaufsbegleitung', desc: 'Gemeinsame Besorgungen im Ort.' },
      { icon: 'users', title: 'Gesellschaft', desc: 'Soziale Kontakte und gemeinsame Aktivitaeten.' },
    ],
    'Einsatzgebiet: Sant Llorenc, Sa Coma, S\'Illot, Son Carrio, Cala Millor, Son Servera.',
    [
      { q: 'Sind Sie regelmaessig in Sant Llorenc?', a: 'Ja, Sant Llorenc und die Kuestenorte gehoeren zu unserem Kerngebiet mit regelmaessigen Besuchen.' },
      { q: 'Koennen Sie kurzfristig kommen?', a: 'Ja, durch unsere Naehe zur Region koennen wir oft innerhalb weniger Stunden vor Ort sein.' },
      { q: 'Gibt es Aerzte in der Naehe?', a: 'Es gibt ein Gesundheitszentrum in Sant Llorenc. Fuer Fachaerzte begleiten wir Sie nach Manacor oder Palma.' },
    ],
    [
      { label: 'Pflege in Cala Millor', slug: 'pflege-cala-millor' },
      { label: 'Pflege in Manacor', slug: 'pflege-manacor' },
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
      { label: 'Hauspflege Mallorca', slug: 'hauspflege-mallorca' },
    ],
    'Pflege Sant Llorenc',
  ),

  'pflege-cala-millor': loc('pflege-cala-millor', 'Pflege Cala Millor', 'Pflege in Cala Millor',
    'Pflege in Cala Millor – Deutschsprachige Betreuung | Geis Care',
    'Pflege in Cala Millor und Cala Bona: Seniorenbetreuung, Hauspflege, Arztbegleitung an der Ostkueste Mallorcas.',
    'Pflege Cala Millor, Seniorenbetreuung Cala Millor, Hauspflege Cala Millor',
    'Cala Millor und Cala Bona an der Ostkueste sind Heimat vieler deutscher Residenten. Geis Care bietet hier massgeschneiderte Pflegeleistungen – ob taegliche Pflege, Strandspaziergang-Begleitung oder medizinische Unterstuetzung. Ihr Vertrauenspartner an der Ostkueste.',
    [
      { icon: 'home', title: 'Hauspflege', desc: 'Pflege zu Hause in Cala Millor und Cala Bona.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zu Aerzten in der Region.' },
      { icon: 'footprints', title: 'Strandspaziergaenge', desc: 'Begleitete Spaziergaenge an der Promenade.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Sichere Medikamentengabe.' },
      { icon: 'cart', title: 'Alltagsbegleitung', desc: 'Einkaufen und Besorgungen in der Umgebung.' },
      { icon: 'clock', title: '24h-Pflege', desc: 'Rund-um-die-Uhr-Pflege verfuegbar.' },
    ],
    'Einsatzgebiet: Cala Millor, Cala Bona, Son Servera, Sa Coma, S\'Illot, Porto Cristo.',
    [
      { q: 'Betreuen Sie auch Ferienwohnungen in Cala Millor?', a: 'Ja, wir betreuen auch Langzeiturlauber in Apartments und Hotels.' },
      { q: 'Wie weit ist das naechste Krankenhaus?', a: 'Das Hospital de Manacor ist ca. 20 Minuten entfernt. Wir begleiten Sie gerne.' },
      { q: 'Bieten Sie Kurzzeitpflege fuer Touristen an?', a: 'Ja, wir bieten flexible Pflege auch fuer kuerzere Aufenthalte.' },
    ],
    [
      { label: 'Pflege in Sant Llorenc', slug: 'pflege-sant-llorenc' },
      { label: 'Pflege in Manacor', slug: 'pflege-manacor' },
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
      { label: 'Pflege in Alcudia', slug: 'pflege-alcudia' },
    ],
    'Pflege Cala Millor',
  ),

  'pflege-inca': loc('pflege-inca', 'Pflege Inca', 'Pflege in Inca und Zentral-Mallorca',
    'Pflege in Inca – Betreuung im Herzen Mallorcas | Geis Care',
    'Professionelle Pflege in Inca und Zentral-Mallorca: Seniorenbetreuung, Hauspflege, Arztbegleitung. Deutschsprachig und persoenlich.',
    'Pflege Inca, Seniorenbetreuung Inca, Hauspflege Inca, Pflege Zentral-Mallorca',
    'Inca liegt zentral im Herzen der Insel, umgeben von malerischen Doerfern und Fincas. Geis Care bietet hier professionelle Pflege fuer deutschsprachige Residenten. Unsere zentrale Lage ermoeglicht schnelle Reaktionszeiten.',
    [
      { icon: 'home', title: 'Hauspflege', desc: 'Pflege zu Hause in Inca und Umgebung.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zum Hospital de Inca und Fachaerzten.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Zuverlaessige Medikamentengabe.' },
      { icon: 'cart', title: 'Marktbegleitung', desc: 'Gemeinsamer Besuch des beruehmten Dijous-Marktes.' },
      { icon: 'footprints', title: 'Spaziergaenge', desc: 'Begleitete Ausfluege in der Umgebung.' },
      { icon: 'heart', title: 'Seniorenbetreuung', desc: 'Liebevolle Begleitung im Alltag.' },
    ],
    'Einsatzgebiet: Inca, Binissalem, Lloseta, Selva, Campanet, Sa Pobla und umliegende Fincas.',
    [
      { q: 'Gibt es ein Krankenhaus in Inca?', a: 'Ja, das Hospital de Inca bietet gute Grundversorgung. Fuer Fachaerzte begleiten wir Sie nach Palma.' },
      { q: 'Betreuen Sie auch die Doerfer um Inca?', a: 'Ja, wir betreuen die gesamte Region: Binissalem, Lloseta, Selva, Campanet und Sa Pobla.' },
      { q: 'Wie kann ich Sie erreichen?', a: 'Kontaktieren Sie uns unter +34 601 889 566 oder per WhatsApp. Wir sind schnell fuer Sie da.' },
    ],
    [
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Pflege in Palma', slug: 'pflege-palma' },
      { label: 'Pflege in Alcudia', slug: 'pflege-alcudia' },
      { label: 'Hauspflege Mallorca', slug: 'hauspflege-mallorca' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
    ],
    'Pflege Inca',
  ),

  'pflege-andratx': loc('pflege-andratx', 'Pflege Andratx', 'Pflege in Andratx und Port d\'Andratx',
    'Pflege in Andratx & Port d\'Andratx – Premium-Betreuung | Geis Care',
    'Exklusive Pflege in Andratx und Port d\'Andratx: Seniorenbetreuung, Hauspflege, Arztbegleitung in Mallorcas Premium-Region.',
    'Pflege Andratx, Pflege Port d\'Andratx, Seniorenbetreuung Andratx, Pflege West-Mallorca',
    'Andratx und Port d\'Andratx gehoeren zu den exklusivsten Wohngegenden Mallorcas. Geis Care bietet hier diskrete, professionelle Pflege auf hoechstem Niveau. Ob Hafenvilla oder Bergfinca – individuelle Betreuung, die zu Ihrem Lebensstil passt.',
    [
      { icon: 'home', title: 'Premium-Hauspflege', desc: 'Exklusive Pflege in Ihrer Villa oder Finca.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zu Aerzten in Andratx und Palma.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Diskrete und zuverlaessige Medikamentengabe.' },
      { icon: 'footprints', title: 'Hafenpromenade', desc: 'Begleitete Spaziergaenge am Hafen von Port d\'Andratx.' },
      { icon: 'clock', title: '24h-Pflege', desc: 'Rund-um-die-Uhr-Pflege in der Region.' },
      { icon: 'lock', title: 'Diskrete Betreuung', desc: 'Hoechste Diskretion und Privatsphaere.' },
    ],
    'Einsatzgebiet: Andratx, Port d\'Andratx, Camp de Mar, Peguera, Santa Ponsa.',
    [
      { q: 'Bieten Sie besonders diskrete Pflege an?', a: 'Ja, Diskretion ist einer unserer Kernwerte. Besonders in Andratx legen wir grossen Wert auf Privatsphaere.' },
      { q: 'Wie weit ist es nach Palma?', a: 'Andratx ist ca. 30 Minuten von Palma entfernt. Wir begleiten Sie gerne zu Fachaerzten.' },
      { q: 'Betreuen Sie auch Gaeste in Ferienhauesern?', a: 'Ja, wir bieten auch temporaere Pflege fuer Urlauber und Saisonresidenten.' },
    ],
    [
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Pflege in Palma', slug: 'pflege-palma' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
      { label: 'Intensivpflege Mallorca', slug: 'intensivpflege-mallorca' },
      { label: 'Aerzte auf Mallorca', slug: 'aerzte-mallorca' },
    ],
    'Pflege Andratx',
  ),

  'pflege-alcudia': loc('pflege-alcudia', 'Pflege Alcudia', 'Pflege in Alcudia und Nord-Mallorca',
    'Pflege in Alcudia & Port d\'Alcudia – Betreuung Nord-Mallorca | Geis Care',
    'Pflege in Alcudia und Port d\'Alcudia: Seniorenbetreuung, Hauspflege, Arztbegleitung im Norden Mallorcas. Deutschsprachig und professionell.',
    'Pflege Alcudia, Pflege Port d\'Alcudia, Seniorenbetreuung Alcudia, Pflege Nord-Mallorca',
    'Alcudia und Port d\'Alcudia im Norden sind beliebte Wohngebiete fuer deutsche Residenten. Geis Care bietet hier professionelle Pflege – von der historischen Altstadt bis zu den Strandapartments. Geniessen Sie das milde Klima, waehrend wir uns um Ihre Pflegebeduerfnisse kuemmern.',
    [
      { icon: 'home', title: 'Hauspflege', desc: 'Pflege zu Hause in Alcudia und Umgebung.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zu Aerzten in Alcudia und Inca.' },
      { icon: 'footprints', title: 'Strandspaziergaenge', desc: 'Begleitete Spaziergaenge an der Bucht von Alcudia.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Zuverlaessige Medikamentengabe.' },
      { icon: 'cart', title: 'Marktbegleitung', desc: 'Gemeinsame Besuche der Wochenmaerkte.' },
      { icon: 'heart', title: 'Seniorenbetreuung', desc: 'Liebevolle Begleitung im Alltag.' },
    ],
    'Einsatzgebiet: Alcudia, Port d\'Alcudia, Can Picafort, Pollenca, Port de Pollenca, Sa Pobla.',
    [
      { q: 'Decken Sie auch Port de Pollenca ab?', a: 'Ja, unser Einsatzgebiet umfasst Alcudia, Pollenca, Port de Pollenca, Can Picafort und umliegende Gemeinden.' },
      { q: 'Gibt es Aerzte in Alcudia?', a: 'Ja, es gibt ein Gesundheitszentrum und Privatpraxen. Fuer Fachaerzte begleiten wir Sie nach Inca oder Palma.' },
      { q: 'Bieten Sie Pflege fuer Ueberwinterer an?', a: 'Ja, viele unserer Klienten sind Langzeiturlauber, die saisonale Pflege benoetigen.' },
    ],
    [
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Pflege in Inca', slug: 'pflege-inca' },
      { label: 'Pflege in Palma', slug: 'pflege-palma' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
      { label: 'Hauspflege Mallorca', slug: 'hauspflege-mallorca' },
    ],
    'Pflege Alcudia',
  ),

  'pflege-santa-ponsa': loc('pflege-santa-ponsa', 'Pflege Santa Ponsa', 'Pflege in Santa Ponsa',
    'Pflege in Santa Ponsa – Deutschsprachige Betreuung Calvia | Geis Care',
    'Professionelle Pflege in Santa Ponsa: Seniorenbetreuung, Hauspflege, Arztbegleitung im Suedwesten Mallorcas.',
    'Pflege Santa Ponsa, Seniorenbetreuung Santa Ponsa, Hauspflege Santa Ponsa',
    'Santa Ponsa ist eine der beliebtesten Wohngegenden fuer deutsche Residenten im Suedwesten Mallorcas. Geis Care bietet hier professionelle, deutschsprachige Pflege – von der Strandpromenade bis zu den Wohnanlagen. Kurze Wege nach Palma und Andratx garantieren hervorragende medizinische Versorgung.',
    [
      { icon: 'home', title: 'Hauspflege', desc: 'Pflege zu Hause in Santa Ponsa und Umgebung.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zu Aerzten in der Region und Palma.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Zuverlaessige Medikamentengabe.' },
      { icon: 'footprints', title: 'Strandspaziergaenge', desc: 'Begleitete Ausfluege an der Promenade.' },
      { icon: 'cart', title: 'Einkaufsbegleitung', desc: 'Gemeinsame Besorgungen im Ort.' },
      { icon: 'clock', title: '24h-Pflege', desc: 'Rund-um-die-Uhr-Pflege verfuegbar.' },
    ],
    'Einsatzgebiet: Santa Ponsa, Paguera, Magaluf, Palmanova, Costa de la Calma.',
    [
      { q: 'Betreuen Sie auch Ferienwohnungen in Santa Ponsa?', a: 'Ja, wir betreuen auch Langzeiturlauber und Saisonresidenten in Ferienwohnungen.' },
      { q: 'Wie weit ist es nach Palma?', a: 'Santa Ponsa ist ca. 20 Minuten von Palma entfernt. Wir begleiten Sie gerne zu Fachaerzten.' },
      { q: 'Gibt es deutschsprachige Aerzte vor Ort?', a: 'Ja, in Santa Ponsa und Umgebung gibt es mehrere deutschsprachige Arztpraxen.' },
    ],
    [
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Pflege in Andratx', slug: 'pflege-andratx' },
      { label: 'Pflege in Palma', slug: 'pflege-palma' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
      { label: 'Hauspflege Mallorca', slug: 'hauspflege-mallorca' },
    ],
    'Pflege Santa Ponsa',
  ),

  'pflege-porto-cristo': loc('pflege-porto-cristo', 'Pflege Porto Cristo', 'Pflege in Porto Cristo',
    'Pflege in Porto Cristo – Betreuung Ostkueste Mallorca | Geis Care',
    'Pflege in Porto Cristo und Umgebung: Seniorenbetreuung, Hauspflege, Arztbegleitung an der Ostkueste.',
    'Pflege Porto Cristo, Seniorenbetreuung Porto Cristo, Hauspflege Porto Cristo',
    'Porto Cristo an der Ostkueste ist bekannt fuer seinen malerischen Hafen und die Cuevas del Drach. Geis Care bietet hier professionelle Pflege fuer deutsche Residenten – ob am Hafen oder in umliegenden Fincas. Das Hospital Parque Llevant garantiert erstklassige medizinische Versorgung vor Ort.',
    [
      { icon: 'home', title: 'Hauspflege', desc: 'Pflege zu Hause in Porto Cristo und Umgebung.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zu Aerzten in Porto Cristo und Manacor.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Zuverlaessige Medikamentengabe.' },
      { icon: 'footprints', title: 'Hafenspaziergaenge', desc: 'Begleitete Ausfluege am Hafen und Strand.' },
      { icon: 'cart', title: 'Alltagsbegleitung', desc: 'Einkaufen und Besorgungen im Ort.' },
      { icon: 'heart', title: 'Seniorenbetreuung', desc: 'Liebevolle Begleitung im Alltag.' },
    ],
    'Einsatzgebiet: Porto Cristo, Cala Anguila, Cala Mandia, Cales de Mallorca, S\'Illot.',
    [
      { q: 'Gibt es ein Krankenhaus in Porto Cristo?', a: 'Ja, das Hospital Parque Llevant bietet 24h-Notaufnahme und alle wichtigen Fachrichtungen.' },
      { q: 'Decken Sie auch die Kuestenorte um Porto Cristo ab?', a: 'Ja, wir decken die gesamte Region ab: Cala Anguila, Cala Mandia, Cales de Mallorca und S\'Illot.' },
      { q: 'Wie schnell koennen Sie vor Ort sein?', a: 'Porto Cristo gehoert zu unserem Kerngebiet. Wir koennen oft innerhalb weniger Stunden vor Ort sein.' },
    ],
    [
      { label: 'Pflege in Manacor', slug: 'pflege-manacor' },
      { label: 'Pflege in Cala Millor', slug: 'pflege-cala-millor' },
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
      { label: 'Kliniken auf Mallorca', slug: 'kliniken-mallorca' },
    ],
    'Pflege Porto Cristo',
  ),

  'pflege-campos': loc('pflege-campos', 'Pflege Campos', 'Pflege in Campos und Sued-Mallorca',
    'Pflege in Campos – Betreuung Sued-Mallorca | Geis Care',
    'Professionelle Pflege in Campos und Umgebung: Seniorenbetreuung, Hauspflege, Arztbegleitung im Sueden Mallorcas.',
    'Pflege Campos, Seniorenbetreuung Campos, Hauspflege Campos, Pflege Sued-Mallorca',
    'Campos im Sueden Mallorcas ist bekannt fuer seine ruhige, laendliche Atmosphaere und die Naehe zu traumhaften Straenden wie Es Trenc. Geis Care bietet hier professionelle Pflege fuer deutschsprachige Residenten – vom Ortskern bis zu umliegenden Fincas.',
    [
      { icon: 'home', title: 'Hauspflege', desc: 'Pflege zu Hause in Campos und Umgebung.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zu Aerzten in Campos, Santanyi und Palma.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Zuverlaessige Medikamentengabe.' },
      { icon: 'cart', title: 'Marktbegleitung', desc: 'Gemeinsame Besuche des Wochenmarkts in Campos.' },
      { icon: 'footprints', title: 'Strandausfluege', desc: 'Begleitete Ausfluege nach Es Trenc und Colonia Sant Jordi.' },
      { icon: 'heart', title: 'Seniorenbetreuung', desc: 'Liebevolle Begleitung im Alltag.' },
    ],
    'Einsatzgebiet: Campos, Colonia Sant Jordi, Es Trenc, Ses Salines, Sa Rapita.',
    [
      { q: 'Betreuen Sie auch abgelegene Fincas bei Campos?', a: 'Ja, wir betreuen auch laendliche Fincas in der Umgebung von Campos und Ses Salines.' },
      { q: 'Gibt es Aerzte in Campos?', a: 'Ja, es gibt ein Gesundheitszentrum in Campos. Fuer Fachaerzte begleiten wir Sie nach Manacor oder Palma.' },
      { q: 'Wie weit ist das naechste Krankenhaus?', a: 'Das Hospital de Manacor ist ca. 30 Minuten entfernt. Wir begleiten Sie gerne.' },
    ],
    [
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Pflege in Manacor', slug: 'pflege-manacor' },
      { label: 'Pflege in Palma', slug: 'pflege-palma' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
      { label: 'Hauspflege Mallorca', slug: 'hauspflege-mallorca' },
    ],
    'Pflege Campos',
  ),

  'pflege-soller': loc('pflege-soller', 'Pflege Soller', 'Pflege in Soller und Port de Soller',
    'Pflege in Soller & Port de Soller – Betreuung Tramuntana-Region | Geis Care',
    'Pflege in Soller und Port de Soller: Seniorenbetreuung, Hauspflege, Arztbegleitung in der Tramuntana-Region.',
    'Pflege Soller, Pflege Port de Soller, Seniorenbetreuung Soller, Pflege Tramuntana',
    'Soller und Port de Soller im Herzen des Tramuntana-Gebirges gehoeren zu den schoensten Orten Mallorcas. Geis Care bietet hier professionelle Pflege fuer deutschsprachige Residenten – ob im Tal oder am Hafen.',
    [
      { icon: 'home', title: 'Hauspflege', desc: 'Pflege zu Hause in Soller und Port de Soller.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zu Aerzten vor Ort und in Palma.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Zuverlaessige Medikamentengabe.' },
      { icon: 'footprints', title: 'Hafenpromenade', desc: 'Begleitete Spaziergaenge am Hafen von Port de Soller.' },
      { icon: 'cart', title: 'Marktbegleitung', desc: 'Gemeinsame Besuche des beruehmten Soller-Marktes.' },
      { icon: 'clock', title: '24h-Pflege', desc: 'Rund-um-die-Uhr-Pflege verfuegbar.' },
    ],
    'Einsatzgebiet: Soller, Port de Soller, Fornalutx, Deia, Bunyola.',
    [
      { q: 'Gibt es Aerzte in Soller?', a: 'Ja, es gibt ein Gesundheitszentrum und die Medcare-Klinik in Port de Soller mit deutschsprachigen Aerzten.' },
      { q: 'Betreuen Sie auch die Bergdoerfer um Soller?', a: 'Ja, wir betreuen auch Fornalutx, Deia und umliegende Fincas in der Tramuntana.' },
      { q: 'Wie ist die Anbindung nach Palma?', a: 'Soller ist ca. 25 Minuten von Palma ueber den Tunnel entfernt. Wir begleiten Sie gerne zu Fachaerzten.' },
    ],
    [
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Pflege in Palma', slug: 'pflege-palma' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
      { label: 'Hauspflege Mallorca', slug: 'hauspflege-mallorca' },
      { label: 'Aerzte auf Mallorca', slug: 'aerzte-mallorca' },
    ],
    'Pflege Soller',
  ),

  'pflege-pollenca': loc('pflege-pollenca', 'Pflege Pollenca', 'Pflege in Pollenca und Port de Pollenca',
    'Pflege in Pollenca & Port de Pollenca – Betreuung Nord-Mallorca | Geis Care',
    'Professionelle Pflege in Pollenca und Port de Pollenca: Seniorenbetreuung, Hauspflege, Arztbegleitung im Norden Mallorcas.',
    'Pflege Pollenca, Pflege Port de Pollenca, Seniorenbetreuung Pollenca, Pflege Nord-Mallorca',
    'Pollenca und Port de Pollenca im Norden Mallorcas verbinden Kultur, Natur und mediterranes Lebensgefuehl. Geis Care bietet hier professionelle, deutschsprachige Pflege – von der historischen Altstadt bis zur Hafenpromenade.',
    [
      { icon: 'home', title: 'Hauspflege', desc: 'Pflege zu Hause in Pollenca und Port de Pollenca.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zu Aerzten in der Region und Inca.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Zuverlaessige Medikamentengabe.' },
      { icon: 'footprints', title: 'Hafenspaziergaenge', desc: 'Begleitete Ausfluege am Hafen und Strand.' },
      { icon: 'cart', title: 'Marktbegleitung', desc: 'Gemeinsame Besuche des Sonntagsmarkts in Pollenca.' },
      { icon: 'heart', title: 'Seniorenbetreuung', desc: 'Liebevolle Begleitung im Alltag.' },
    ],
    'Einsatzgebiet: Pollenca, Port de Pollenca, Cala Sant Vicenc, Alcudia, Formentor.',
    [
      { q: 'Gibt es Aerzte in Pollenca?', a: 'Ja, es gibt ein Gesundheitszentrum in Pollenca. Fuer Fachaerzte begleiten wir Sie nach Inca oder Palma.' },
      { q: 'Decken Sie auch Cala Sant Vicenc und Formentor ab?', a: 'Ja, unser Einsatzgebiet umfasst die gesamte Region Pollenca bis zur Halbinsel Formentor.' },
      { q: 'Bieten Sie Pflege fuer Saisonresidenten an?', a: 'Ja, viele unserer Klienten sind Langzeiturlauber und Saisonresidenten in der Region.' },
    ],
    [
      { label: 'Pflege in Alcudia', slug: 'pflege-alcudia' },
      { label: 'Pflege in Inca', slug: 'pflege-inca' },
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
      { label: 'Hauspflege Mallorca', slug: 'hauspflege-mallorca' },
    ],
    'Pflege Pollenca',
  ),

  'pflege-calvia': loc('pflege-calvia', 'Pflege Calvia', 'Pflege in Calvia und Umgebung',
    'Pflege in Calvia – Betreuung Suedwest-Mallorca | Geis Care',
    'Pflege in Calvia und Umgebung: Seniorenbetreuung, Hauspflege, Arztbegleitung im Suedwesten.',
    'Pflege Calvia, Seniorenbetreuung Calvia, Hauspflege Calvia, Pflege Suedwest-Mallorca',
    'Die Gemeinde Calvia im Suedwesten Mallorcas umfasst beliebte Orte wie Santa Ponsa, Paguera, Palmanova und Magaluf. Geis Care bietet hier professionelle, deutschsprachige Pflege – von der Kueste bis ins Hinterland.',
    [
      { icon: 'home', title: 'Hauspflege', desc: 'Pflege zu Hause in der gesamten Gemeinde Calvia.' },
      { icon: 'car', title: 'Arztbegleitung', desc: 'Begleitung zu Aerzten vor Ort und in Palma.' },
      { icon: 'pill', title: 'Medikamentenverwaltung', desc: 'Zuverlaessige Medikamentengabe.' },
      { icon: 'footprints', title: 'Strandspaziergaenge', desc: 'Begleitete Ausfluege an der Kueste.' },
      { icon: 'cart', title: 'Einkaufsbegleitung', desc: 'Gemeinsame Besorgungen im Ort.' },
      { icon: 'clock', title: '24h-Pflege', desc: 'Rund-um-die-Uhr-Pflege verfuegbar.' },
    ],
    'Einsatzgebiet: Calvia, Santa Ponsa, Paguera, Palmanova, Magaluf, Costa de la Calma, Sol de Mallorca.',
    [
      { q: 'In welchen Orten von Calvia sind Sie taetig?', a: 'Wir decken die gesamte Gemeinde ab: Santa Ponsa, Paguera, Palmanova, Magaluf und alle weiteren Orte.' },
      { q: 'Gibt es deutschsprachige Aerzte in Calvia?', a: 'Ja, es gibt mehrere deutschsprachige Arztpraxen und Gesundheitszentren in der Region.' },
      { q: 'Wie weit ist es nach Palma?', a: 'Calvia liegt je nach Ort zwischen 15 und 25 Minuten von Palma entfernt.' },
    ],
    [
      { label: 'Pflege in Santa Ponsa', slug: 'pflege-santa-ponsa' },
      { label: 'Pflege in Andratx', slug: 'pflege-andratx' },
      { label: 'Pflege in Palma', slug: 'pflege-palma' },
      { label: 'Pflege Mallorca', slug: 'pflege-mallorca' },
      { label: 'Seniorenbetreuung Mallorca', slug: 'seniorenbetreuung-mallorca' },
    ],
    'Pflege Calvia',
  ),
};
